import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { user, isAuthenticated, hydrated } = useContext(LoginContext);

  if (!hydrated) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  const role = String(user?.tiu_descripcion || '').toUpperCase();
  if (allowedRoles.length && !allowedRoles.map((r) => String(r).toUpperCase()).includes(role)) {
    return <Navigate to="/administrador/home" replace />;
  }

  return children;
};

export default ProtectedRoute;
